/* The chat (snippets/me-chat.liquid). Instant help: sends the conversation to the mx-pack worker /chat and draws the
   streamed reply, text as it arrives, then any cards Claude asked for (templates, packs, a button) and reply chips.
   Feedback: a note to Kaitlin, sent to Shopify's contact form (the store inbox) and kept by the worker (/feedback).
   The conversation is kept for the visit in sessionStorage ('mxc-log'), so it survives moving between pages. */
(function () {
  var root = document.querySelector('[data-mxc]');
  if (!root || root.dataset.wired) { return; }
  root.dataset.wired = '1';

  var endpoint = root.getAttribute('data-endpoint').replace(/\/$/, '');
  var signedIn = root.getAttribute('data-signed-in') === '1';
  var q = function (s) { return root.querySelector(s); };
  var launch = q('[data-mxc-open]'), panel = q('[data-mxc-panel]'), log = q('[data-mxc-log]'), hello = q('[data-mxc-hello]');
  var form = q('[data-mxc-form]'), input = q('[data-mxc-input]'), sendBtn = q('[data-mxc-send]');
  var nudge = q('[data-mxc-nudge]');
  var history = [], busy = false;

  function store(key, value) { try { if (value == null) { sessionStorage.removeItem(key); } else { sessionStorage.setItem(key, value); } } catch (e) { /* private mode */ } }
  function read(key) { try { return sessionStorage.getItem(key); } catch (e) { return null; } }

  function el(tag, cls, text) { var n = document.createElement(tag); if (cls) { n.className = cls; } if (text != null) { n.textContent = text; } return n; }
  function scrollDown(smooth) { log.scrollTo({ top: log.scrollHeight, behavior: smooth ? 'smooth' : 'auto' }); }

  /* Plain text with links: https URLs, /pages/… paths and email addresses become links. Nothing else is interpreted. */
  function linkify(node, text) {
    node.textContent = '';
    var re = /(https?:\/\/[^\s)]+|\/pages\/[a-z0-9-]+(?:\?[^\s)]*)?|[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,})/gi, last = 0, m;
    text = text.replace(/\*\*(.+?)\*\*/g, '$1');
    while ((m = re.exec(text))) {
      if (m.index > last) { node.appendChild(document.createTextNode(text.slice(last, m.index))); }
      var a = el('a', null, m[0]);
      var href = m[0].replace(/[.,]$/, '');
      a.href = href.indexOf('@') > 0 && href.indexOf('/') < 0 ? 'mailto:' + href : href;
      if (/^https?:/.test(href) && href.indexOf(location.host) < 0) { a.target = '_blank'; a.rel = 'noopener'; }
      node.appendChild(a);
      last = m.index + m[0].length;
    }
    if (last < text.length) { node.appendChild(document.createTextNode(text.slice(last))); }
  }

  function userBubble(text) {
    var row = el('div', 'mxc__row mxc__row--me');
    row.appendChild(el('div', 'mxc__bubble mxc__bubble--me', text));
    log.appendChild(row);
  }
  function botRow() {
    var row = el('div', 'mxc__row mxc__row--bot');
    var col = el('div', 'mxc__col');
    var bubble = el('div', 'mxc__bubble mxc__bubble--bot');
    col.appendChild(bubble); row.appendChild(col);
    log.appendChild(row);
    return { row: row, col: col, bubble: bubble };
  }
  function typing(bubble) { bubble.classList.add('is-typing'); bubble.innerHTML = '<i></i><i></i><i></i>'; }

  /* ---- cards ---- */
  function templatesCard(items) {
    var wrap = el('div', 'mxc__cards');
    items.forEach(function (it, i) {
      var a = el('a', 'mxc__tpl');
      a.href = '/pages/creator-studio?t=' + encodeURIComponent(it.u);
      a.style.setProperty('--i', i);
      var fig = el('span', 'mxc__tpl-img');
      var img = el('img'); img.alt = ''; img.loading = 'lazy'; img.src = it.img;
      img.addEventListener('load', function () { a.classList.add('is-loaded'); });
      fig.appendChild(img);
      a.appendChild(fig);
      a.appendChild(el('span', 'mxc__tpl-name', it.n));
      a.appendChild(el('span', 'mxc__tpl-go', 'Try it on'));
      wrap.appendChild(a);
    });
    return wrap;
  }
  function packsCard(packs, pick) {
    var wrap = el('div', 'mxc__packs');
    packs.forEach(function (p) {
      var a = el('a', 'mxc__pack' + (p.variant === pick ? ' is-pick' : ''));
      a.href = '/cart/' + p.variant + ':1';
      a.appendChild(el('span', 'mxc__pack-n', (p.credits || p.images * 5) + ' credits'));
      a.appendChild(el('span', 'mxc__pack-each', p.variant === pick ? 'Our pick for you' : 'Changes included'));
      a.appendChild(el('span', 'mxc__pack-price', '$' + p.price));
      wrap.appendChild(a);
    });
    wrap.appendChild(el('div', 'mxc__packs-note', 'You start with 5 free credits. A mockup is 5, a video 20.'));
    return wrap;
  }
  function buttonCard(label, href) {
    var a = el('a', 'mxc__btn', label); a.href = href;
    if (href.indexOf('mailto:') === 0) { a.classList.add('mxc__btn--light'); }
    if (href === '#feedback') {
      a.classList.add('mxc__btn--pink');
      a.addEventListener('click', function (e) { e.preventDefault(); openFeedback(lastUserText()); });
    }
    return a;
  }
  function lastUserText() { for (var i = history.length - 1; i >= 0; i--) { if (history[i].role === 'user') { return history[i].text; } } return ''; }
  function chips(replies, into) {
    var wrap = el('div', 'mxc__chips');
    replies.forEach(function (r, i) {
      var b = el('button', 'mxc__chip', r); b.type = 'button'; b.style.setProperty('--i', i);
      wrap.appendChild(b);
    });
    into.appendChild(wrap);
  }

  /* ---- sending ---- */
  function clearChips() { Array.prototype.forEach.call(log.querySelectorAll('.mxc__chips:not(.mxc__chips--start)'), function (c) { c.remove(); }); }

  function send(text) {
    text = (text || '').trim();
    if (!text || busy) { return; }
    busy = true; sendBtn.disabled = true;
    clearChips();
    hello.classList.add('is-small');
    userBubble(text);
    history.push({ role: 'user', text: text });
    save();
    var bot = botRow(); typing(bot.bubble);
    scrollDown(true);

    var answer = '', extras = [];
    function write(chunk) {
      if (bot.bubble.classList.contains('is-typing')) { bot.bubble.classList.remove('is-typing'); bot.bubble.textContent = ''; bot.bubble.classList.add('is-streaming'); }
      answer += chunk;
      linkify(bot.bubble, answer);
      stickToBottom();
    }
    function handle(evt) {
      if (evt.t === 'text') { write(evt.d); }
      else if (evt.t === 'templates' && evt.items && evt.items.length) { bot.col.appendChild(templatesCard(evt.items)); extras.push(evt); stickToBottom(); }
      else if (evt.t === 'packs') { bot.col.appendChild(packsCard(evt.packs, evt.pick)); extras.push(evt); stickToBottom(); }
      else if (evt.t === 'button') { bot.col.appendChild(buttonCard(evt.label, evt.href)); extras.push(evt); stickToBottom(); }
      else if (evt.t === 'chips') { chips(evt.replies, bot.col); stickToBottom(); }
      else if (evt.t === 'error') { write((answer ? '\n\n' : '') + evt.d); }
    }
    function finish() {
      bot.bubble.classList.remove('is-streaming');
      if (bot.bubble.classList.contains('is-typing')) { bot.bubble.classList.remove('is-typing'); bot.bubble.textContent = answer || 'Sorry, nothing came back. Try again?'; }
      if (!answer.trim()) { bot.bubble.hidden = !!extras.length; }
      history.push({ role: 'assistant', text: answer.trim() || '(showed ' + extras.map(function (x) { return x.t; }).join(', ') + ')', extras: extras });
      save();
      busy = false; sendBtn.disabled = !input.value.trim();
      stickToBottom();
    }

    fetch(endpoint + '/chat', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ messages: history.map(function (m) { return { role: m.role, text: m.text }; }), page: location.pathname, signedIn: signedIn })
    }).then(function (res) {
      if (!res.ok || !res.body) {
        return res.json().catch(function () { return {}; }).then(function (b) { handle({ t: 'error', d: b.error || 'Could not reach the chat just now. Try again in a moment.' }); });
      }
      var reader = res.body.getReader(), dec = new TextDecoder(), buf = '';
      function pump() {
        return reader.read().then(function (r) {
          if (r.done) { return; }
          buf += dec.decode(r.value, { stream: true });
          var parts = buf.split('\n\n'); buf = parts.pop();
          parts.forEach(function (p) {
            var line = p.split('\n').filter(function (l) { return l.indexOf('data: ') === 0; }).map(function (l) { return l.slice(6); }).join('');
            if (line) { try { handle(JSON.parse(line)); } catch (e) { /* partial */ } }
          });
          return pump();
        });
      }
      return pump();
    }).catch(function () { handle({ t: 'error', d: 'Could not reach the chat just now. Check your connection and try again.' }); })
      .then(finish);
  }

  var nearBottom = true;
  log.addEventListener('scroll', function () { nearBottom = log.scrollHeight - log.scrollTop - log.clientHeight < 80; }, { passive: true });
  function stickToBottom() { if (nearBottom) { scrollDown(false); } }

  /* ---- keep the visit's conversation ---- */
  function save() { store('mxc-log', JSON.stringify(history.slice(-24))); }
  function restore() {
    var raw = read('mxc-log'); if (!raw) { return; }
    try { history = JSON.parse(raw) || []; } catch (e) { history = []; }
    if (!history.length) { return; }
    hello.classList.add('is-small');
    history.forEach(function (m) {
      if (m.role === 'user') { userBubble(m.text); return; }
      var bot = botRow();
      if (/^\(showed /.test(m.text)) { bot.bubble.hidden = true; } else { linkify(bot.bubble, m.text); }
      (m.extras || []).forEach(function (x) {
        if (x.t === 'templates') { bot.col.appendChild(templatesCard(x.items)); }
        if (x.t === 'packs') { bot.col.appendChild(packsCard(x.packs, x.pick)); }
        if (x.t === 'button') { bot.col.appendChild(buttonCard(x.label, x.href)); }
      });
    });
  }

  /* ---- feedback to Kaitlin ---- */
  var fb = q('[data-mxc-fb]'), fbForm = q('[data-mxc-fb-form]'), fbText = q('[data-mxc-fb-text]'), fbEmail = q('[data-mxc-fb-email]');
  var fbSend = q('[data-mxc-fb-send]'), fbError = q('[data-mxc-fb-error]'), fbDone = q('[data-mxc-fb-done]'), back = q('[data-mxc-back]');
  function openFeedback(prefill) {
    fb.hidden = false; fbForm.hidden = false; fbDone.hidden = true; fbError.hidden = true; back.hidden = false;
    if (prefill && !fbText.value) { fbText.value = prefill; }
    requestAnimationFrame(function () { fb.classList.add('is-in'); fbText.focus(); });
  }
  function closeFeedback() {
    fb.classList.remove('is-in'); back.hidden = true;
    setTimeout(function () { if (!fb.classList.contains('is-in')) { fb.hidden = true; } }, 250);
  }
  q('[data-mxc-fb-open]').addEventListener('click', function () { openFeedback(''); });
  q('[data-mxc-fb-close]').addEventListener('click', closeFeedback);
  back.addEventListener('click', closeFeedback);
  q('[data-mxc-help]').addEventListener('click', function () { input.focus(); input.classList.add('is-flash'); setTimeout(function () { input.classList.remove('is-flash'); }, 900); });
  fbForm.addEventListener('submit', function (e) {
    e.preventDefault();
    var text = fbText.value.trim(), email = fbEmail.value.trim();
    if (text.length < 2) { fbText.focus(); return; }
    fbSend.disabled = true; fbError.hidden = true; fbSend.querySelector('span').textContent = 'Sending…';
    /* Store inbox: Shopify's own contact form. */
    var shop = new FormData();
    shop.append('form_type', 'contact'); shop.append('utf8', '✓');
    shop.append('contact[name]', root.getAttribute('data-name') || 'Chat');
    shop.append('contact[email]', email || 'no-reply@mockexchange.co');
    shop.append('contact[body]', 'Feedback from the chat (' + location.pathname + '):\n\n' + text + (email ? '' : '\n\n(no email left)'));
    var toShop = fetch('/contact', { method: 'POST', body: shop, credentials: 'same-origin' }).then(function (r) { return r.ok && !/challenge/.test(r.url); }).catch(function () { return false; });
    var toWorker = fetch(endpoint + '/feedback', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ text: text, email: email, name: root.getAttribute('data-name') || '', page: location.pathname }) })
      .then(function (r) { return r.ok; }).catch(function () { return false; });
    Promise.all([toShop, toWorker]).then(function (ok) {
      fbSend.disabled = false; fbSend.querySelector('span').textContent = 'Send to Kaitlin';
      if (!ok[0] && !ok[1]) { fbError.textContent = 'That didn’t send. Try again, or email hello@mockexchange.co.'; fbError.hidden = false; return; }
      fbText.value = '';
      q('[data-mxc-fb-done-text]').textContent = email ? 'I read every one of these, and I’ll reply to ' + email + '.' : 'I read every one of these.';
      fbForm.hidden = true; fbDone.hidden = false;
    });
  });

  /* ---- open, close, start over ---- */
  function open() {
    panel.hidden = false; root.classList.add('is-open'); launch.setAttribute('aria-expanded', 'true'); launch.setAttribute('aria-label', 'Close chat');
    hideNudge(true);
    requestAnimationFrame(function () { panel.classList.add('is-in'); if (history.length) { scrollDown(false); } else { log.scrollTop = 0; } if (window.matchMedia('(min-width: 700px)').matches) { input.focus(); } });
    store('mxc-open', '1');
  }
  function close() {
    panel.classList.remove('is-in'); root.classList.remove('is-open'); launch.setAttribute('aria-expanded', 'false'); launch.removeAttribute('aria-label');
    setTimeout(function () { if (!root.classList.contains('is-open')) { panel.hidden = true; } }, 250);
    store('mxc-open', null);
    launch.focus();
  }
  launch.addEventListener('click', function () { if (root.classList.contains('is-open')) { close(); } else { open(); } });
  q('[data-mxc-close]').addEventListener('click', close);
  q('[data-mxc-reset]').addEventListener('click', function () {
    if (busy) { return; }
    history = []; save();
    Array.prototype.forEach.call(log.querySelectorAll('.mxc__row'), function (r) { r.remove(); });
    clearChips(); hello.classList.remove('is-small'); closeFeedback(); input.focus();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root.classList.contains('is-open')) { if (!fb.hidden) { closeFeedback(); } else { close(); } } });

  log.addEventListener('click', function (e) {
    var chip = e.target.closest && e.target.closest('.mxc__chip');
    if (chip) { send(chip.textContent); }
  });
  input.addEventListener('input', function () {
    sendBtn.disabled = busy || !input.value.trim();
    input.style.height = 'auto'; input.style.height = Math.min(input.scrollHeight, 120) + 'px';
  });
  input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && !e.shiftKey && !e.isComposing) { e.preventDefault(); form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true })); }
  });
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var t = input.value; input.value = ''; input.style.height = 'auto'; sendBtn.disabled = true;
    send(t);
  });

  /* ---- a small hello bubble, once a visit, not in the studio ---- */
  function hideNudge(forever) { nudge.classList.remove('is-in'); setTimeout(function () { nudge.hidden = true; }, 250); if (forever) { store('mxc-nudged', '1'); } }
  q('[data-mxc-nudge-x]').addEventListener('click', function (e) { e.stopPropagation(); hideNudge(true); });
  nudge.addEventListener('click', function () { open(); });
  if (!read('mxc-nudged') && !document.querySelector('.mv-studio') && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    setTimeout(function () {
      if (root.classList.contains('is-open') || read('mxc-nudged')) { return; }
      nudge.hidden = false; requestAnimationFrame(function () { nudge.classList.add('is-in'); });
      store('mxc-nudged', '1');
      setTimeout(function () { hideNudge(false); }, 9000);
    }, 9000);
  }

  restore();
  if (read('mxc-open') && !document.querySelector('.mv-studio')) { open(); }
})();
